import { FunctionComponent, ReactElement, useCallback } from "react";
import { Amount } from "../../../../../../components";
import { colors } from "../../../../../../styles/colors";
import { Icon } from "../../../../../../ui";
import styles from "./Saving.module.scss";
import { ISavingProps } from "./types";

export const Saving: FunctionComponent<ISavingProps> = (
  props: ISavingProps
): ReactElement<ISavingProps> => {
  const { saving, onPress, ...restProps } = props;

  const doPress = useCallback(() => {
    onPress(saving);
  }, [saving, onPress]);

  return (
    <div className="col-lg-3 cardCol" {...restProps}>
      <div className="card smallCard mainBlockBg" onClick={doPress}>
        <Icon
          backgroundColor={saving.color}
          className={styles.iconDefault}
          color={colors.palette.white}
          icon={saving.icon}
          size={32}
        />
        <div className="cardContent">
          <Amount
            className="cardContentValue"
            currency={saving.currency}
            value={saving.balance}
          />
          <span className="cardContentLabel">{saving.name}</span>
        </div>
      </div>
    </div>
  );
};
